import { render, staticRenderFns } from "./retention_yukon.vue?vue&type=template&id=2640e1f5&"
import script from "./retention_yukon.vue?vue&type=script&lang=js&"
export * from "./retention_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports